<template>
  <div id="performance-report-section-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3">
            <label for="table_name_zh" class="form-label">中文名稱</label>
            <input v-model="form.table_name_zh" id="table_name_zh" type="text" class="form-control w-full" placeholder="請輸入中文名稱">
            <div v-if="'table_name_zh' in errors" class="text-danger mt-2" v-html="errors.table_name_zh"></div>
          </div>

          <div class="mt-3">
            <label for="table_name_en" class="form-label">英文名稱</label>
            <input v-model="form.table_name_en" id="table_name_en" type="text" class="form-control w-full" placeholder="請輸入英文名稱">
            <div v-if="'table_name_en' in errors" class="text-danger mt-2" v-html="errors.table_name_en"></div>
          </div>

          <div class="mt-3">
            <label for="table_index" class="form-label">表格ID</label>
            <input v-model="form.table_index" id="table_index" type="text" class="form-control w-full" placeholder="請輸入表格ID">
            <div v-if="'table_index' in errors" class="text-danger mt-2" v-html="errors.table_index"></div>
          </div>

          <div v-if="false" class="form-switch mt-3">
            <label class="form-label">是否計算總數</label>
            <div class="mt-1">
              <input v-model="form.is_count_total" type="checkbox" class="form-check-input">
            </div>
          </div>

          <div class="mt-3">
            <label for="footer" class="form-label">備註</label>
            <ckeditor :editor="editor" v-model="form.footer" :config="editorConfig" />
            <div v-if="'footer' in errors" class="text-danger mt-2" v-html="errors.footer"></div>
          </div>

          <div class="mt-3">
            <label for="display_order" class="form-label"><span class="text-danger">*</span> 顯示次序</label>
            <input v-model="form.display_order" id="display_order" type="number" class="form-control w-full" placeholder="請輸入顯示次序">
            <div v-if="'display_order' in errors" class="text-danger mt-2" v-html="errors.display_order"></div>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" :to="`/management/performance-reports/${this.$route.params.sectionId}`" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>

    <file-insertor :auth="auth" :current-site="currentSite" :permissions="permissions" :profile="profile" @on-select="onSelectInsertFile" ref="fileInsertor"></file-insertor>
  </div>
</template>

<script>
/* global CKEDITOR */
import InsertLibraryFile from '../extension/ckeditorInsertLibraryFile'

const {
  ClassicEditor,
  Alignment,
  Autoformat,
  AutoImage,
  AutoLink,
  Autosave,
  Base64UploadAdapter,
  Bold,
  CloudServices,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Fullscreen,
  GeneralHtmlSupport,
  Highlight,
  HorizontalLine,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  SourceEditing,
  Strikethrough,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TodoList,
  Underline
} = CKEDITOR

export default {
  props: ['data', 'auth', 'currentSite', 'permissions', 'profile'],
  data() {
    return {
      mode: 'create',
      sites: [],
      form: {
        table_name_zh: null,
        table_name_en: null,
        table_index: null,
        footer: null,
        is_count_total: false,
        display_order: null
      },
      errors: {},
      loading: false,
      finish: false,

      editor: ClassicEditor,
      editorConfig: {
        licenseKey: process.env.VUE_APP_CKEDITOR5_LICENSE_KEY, // Or 'GPL'.
        bodyClass: 'html-content',
        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'sourceEditing',
            'fullscreen',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'removeFormat',
            '|',
            'horizontalLine',
            'link',
            'insertLibraryFile',
            // 'insertImage',
            'mediaEmbed',
            'insertTable',
            'highlight',
            '|',
            'alignment',
            '|',
            'bulletedList',
            'numberedList',
            'todoList',
            'outdent',
            'indent'
          ],
          shouldNotGroupWhenFull: true
        },
        plugins: [
          InsertLibraryFile,
          Alignment,
          Autoformat,
          AutoImage,
          AutoLink,
          Autosave,
          Base64UploadAdapter,
          Bold,
          CloudServices,
          Essentials,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          Fullscreen,
          GeneralHtmlSupport,
          Highlight,
          HorizontalLine,
          ImageBlock,
          ImageCaption,
          ImageInline,
          ImageInsert,
          ImageInsertViaUrl,
          ImageResize,
          ImageStyle,
          ImageTextAlternative,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          Paragraph,
          PasteFromOffice,
          RemoveFormat,
          SourceEditing,
          Strikethrough,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline
        ],
        insertLibraryFile: {
          onButtonClickCallback: this.showFileInsertor
        },
        fontFamily: {
          options: ['新細明體', '細明體', '標楷體', '微軟正黑體', '微軟雅黑體', 'serif', 'sans-serif', 'monospace', 'Times New Roman', 'Arial', 'Helvetica', 'Calibri']
        },
        fontSize: {
          options: [10, 12, 'default', 16, 18, 20, 22],
          supportAllValues: true
        },
        fullscreen: {
          onEnterCallback: container =>
            container.classList.add(
              'editor-container',
              'editor-container_classic-editor',
              'editor-container_include-fullscreen',
              'main-container'
            )
        },
        htmlSupport: {
          allow: [
            {
              name: /^.*$/,
              styles: true,
              attributes: true,
              classes: true
            }
          ]
        },
        image: {
          toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage'
          ]
        },
        link: {
          addTargetToExternalLinks: true,
          decorators: {
            isOpenInNewTab: {
              mode: 'manual',
              label: '在新視窗打開',
              defaultValue: true,
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            }
          }
        },
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        },
        placeholder: '',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
        }
      },
      ckeditorInsertLibraryFileCommand: null
    }
  },
  watch: {
    data(val) {
      this.init()
    }
  },
  mounted() {
    window.tailwind.svgLoader()
    this.init()
  },
  methods: {
    init() {
      if (this.data != null) {
        this.form = this.data
        this.mode = 'update'
      }
    },
    showFileInsertor(ckeditorCommand) {
      this.ckeditorInsertLibraryFileCommand = ckeditorCommand
      this.$refs.fileInsertor.onShow()
    },
    async onSelectInsertFile(file) {
      if (file.file.format.mime_type.startsWith('image/')) {
        const image = await this.getLibraryItem(this.currentSite.site_id, file.item_code)
        this.ckeditorInsertLibraryFileCommand(true, image.data.public_url)
      } else {
        this.ckeditorInsertLibraryFileCommand(false, `/file/${file.item_code}`, file.item_name)
      }
    },
    onSave: async function() {
      this.loading = true
      this.errors = {}

      let response

      if (this.mode === 'create') {
        response = await this.createPerformanceReportSectionTable(this.$route.params.sectionId, this.form)
      } else {
        response = await this.updatePerformanceReportSectionTable(this.$route.params.sectionId, this.data.table_id, this.form)
      }

      if ('errors' in response.data) {
        this.errors = response.data.errors
        this.loading = false
      } else {
        let option = {
          title: (this.mode === 'create') ? '已成功新增表格' : '已成功更新表格',
          message: '請稍後，將會轉至執行報告頁面',
          type: 'success'
        }

        if (response.code === 0) {
          this.finish = true

          setTimeout(() => {
            this.$router.push(`/management/performance-reports/${this.$route.params.sectionId}`)
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: (this.mode === 'create') ? '未能新增表格' : '未能更新表格',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss">
#performance-report-section-form {
  ::v-deep {
    .ql-editor {
      height: 100%;
      flex: 1;
      overflow-y: auto;
      width: 100%;
    }
  }
}
</style>
